import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Icon, TextField, Layout, Button, Checkbox, Badge, Page, Card, ChoiceList, Text, BlockStack, InlineStack, InlineGrid, Box, Divider } from '@shopify/polaris';
import { AlertCircleIcon, DeleteIcon, EditIcon, PlayCircleIcon } from '@shopify/polaris-icons';
import Creatable from '../Creatable';
import ReactSelect from '../ReactSelect';
import { setToast } from '../../store/actions/configActions';
import AdvancedOptions from '../AdvancedOptions';
import { useNavigate, useParams } from 'react-router-dom';
import './style.css'
import CustomToggle from '../CustomToggle';
import ShippingExceptions from '../ShippingExceptions';
import constants from '../../store/constants';
import { saveRate } from '../../api/rates';
import { formatCurrency, validateInput, validateString } from '../../helper';
import PolarisModal from '../PolarisModal';
import WarningCard from '../WarningCard';
import useAuthenticatedFetch from '../../hooks/useAuthenticatedFetch';

const emptyRange = { id: '', shipping_id: '', shipping_name: '', from: '', upto: '', cost: '' }
const weightUnits = {
    "kg": "kilogram",
    "lb": "pound",
    "oz": "ounce"
}

const RateSetting = () => {
    const navigate = useNavigate()
    const params = useParams()
    const rateId = isNaN(Number(params.id)) ? null : Number(params.id)
    const [conditions, setConditions] = useState([])
    const fetchJson = useAuthenticatedFetch()

    const { shopName, store, currency, statesList, locations, countries, country, features } = useSelector(state => state.ConfigReducer)
    const { shippingList } = useSelector(state => state.ShippingReducer)
    const dispatch = useDispatch()

    const [ranges] = useState(features.indexOf(constants.RANGES) >= 0)
    const [checkout_ui] = useState(features.indexOf(constants.CHECKOUT_UI) >= 0)
    const [Rate, setRate] = useState({
        "display_name": '',
        "title": '',
        "shipping_by": 'zip',
        "charge_by": 'no',
        "default_cost": '',
        "multiply_base_price": false,
        "add_base_price": false,
        "description": null,
        "active": true,
        "cost_by": 'flat',
        "shipping_ranges": [],
        "shipping_conditions": {
            "min_spent": null,
            "max_spent": null,
        },
        "zip_codes": null,
        "cities": null,
        "states": null,
        "countries": null,
        "exp_zip_codes": null,
        "exp_cities": null,
        "exp_states": null,
        "unit": 'kg',
        "priceBy": 'flat',
        "currency": currency ? currency : '',
        "shop": shopName,
        "locIds": ''
    })
    const [exceptions, setExceptions] = useState([])
    const [loading, setLoading] = useState(false)
    // const [active, setActive] = useState(false) // active location dropdown
    const [OpenWarning, setOpenWarning] = useState(false)

    const [zipInputValue, setZipInputValue] = useState('')
    const [cityInputValue, setCityInputValue] = useState('')
    const [DeletedRanges, setDeletedRanges] = useState([])
    const [Error, setError] = useState({ isErr: false, msg: null })
    const [chargeDisabled, setChargeDisabled] = useState(false)
    const [errors, setErrors] = useState({}); // shipping rate form errors
    const [isSaving, setIsSaving] = useState(false)
    const [locs, setLocs] = useState([])
    const [ratesPermission] = useState(features.indexOf(constants.RATES) >= 0)
    const [exp] = useState(features.indexOf(constants.EXCEPTIONS) >= 0)
    const [deleting, setDeleting] = useState(false)
    const [advanced, setAdvanced] = useState(false)
    const [editLabel, setEditLabel] = useState(false)

    const handleChangeCondition = useCallback(value => {
        setConditions(value)
    }, []);

    useEffect(() => {
        const getSingleShipping = async rateId => {
            setLoading(true)
            try {
                const shippings = await fetchJson(`/shipping/get/${rateId}`, {
                    method: "GET"
                })
                if (shippings) {
                    const rate = shippings?.shippingData
                    let ship_cond = rate.shipping_conditions
                    let conditions = { min_spent: null, max_spent: null }
                    if (ship_cond && ship_cond.length) {
                        let minSpent = ship_cond.filter(cond => cond.condition === "min_spent")
                        let maxSpent = ship_cond.filter(cond => cond.condition === "max_spent")

                        if (minSpent && minSpent.length) conditions.min_spent = minSpent[0].value
                        if (maxSpent && maxSpent.length) conditions.max_spent = maxSpent[0].value
                        setConditions(ship_cond.map(cond => cond.condition))
                    }

                    let ranges = rate.shipping_ranges
                    if (ranges.length === 0) {
                        ranges.push({ ...emptyRange })
                    }
                    setRate(r => ({ ...r, ...rate, shipping_ranges: ranges, shipping_conditions: conditions }))
                    setChargeDisabled(!ranges || rate.charge_by === "no")
                    if (rate.description || rate.delivery || rate.add_base_price || rate.multiply_base_price || (ship_cond && ship_cond.length) || rate.exp_zip_codes || rate.exp_cities || rate.exp_states) {
                        setAdvanced(true)
                    }
                } else {
                    // dispatch(setToast({ active: true, content: "Please try again", error: false }))
                    addRange()
                }
            } catch (error) {
                dispatch(setToast({ active: true, content: error.message, error: true }))
            } finally {
                setLoading(false)
            }
        }

        if (rateId && store?.shop_id) {
            getSingleShipping(rateId)
        } else {
            addRange()
        }
        // if (rateId && shippingList.length) {
        //     let index = shippingList.findIndex(s => s.id === rateId)
        //     setChargeDisabled(shippingList[index].charge_by === 'no')
        //     if (shippingList[index].charge_by === 'no') {
        //         let ranges = shippingList[index].shipping_ranges
        //         if (ranges.length === 0) {
        //             ranges.push({ ...emptyRange })
        //             shippingList[index].shipping_ranges = [...ranges]
        //         }
        //     }

        //     let ship_cond = shippingList[index].shipping_conditions

        //     let conditions = { min_spent: null, max_spent: null }
        //     if (ship_cond && ship_cond.length) {
        //         let minSpent = ship_cond.filter(cond => cond.condition === "min_spent")
        //         let maxSpent = ship_cond.filter(cond => cond.condition === "max_spent")

        //         if (minSpent && minSpent.length) conditions.min_spent = minSpent[0].value
        //         if (maxSpent && maxSpent.length) conditions.max_spent = maxSpent[0].value
        //         setConditions(ship_cond.map(cond => cond.condition))
        //     }

        //     setRate(r => ({ ...r, ...shippingList[index], shipping_conditions: conditions }))
        // } else {
        //     addRange()
        // }
        // if (locs.length === 0 && locations.length > 0) {
        //     const list = locations.map(l => ({ "label": l.name, "value": l.location_id.toString() }))
        //     setLocs([...list])
        // }
    }, [rateId, store?.shop_id])

    const rangesAdded = data => data.some(item => item.from !== '' || item.upto !== '' || item.cost !== '')

    const handleChangeRate = obj => {
        let error = ''
        for (const key in obj) {
            const value = obj[key];
            if (value !== null && value !== '' && errors[key]) {
                if (key === "default_cost" && value < 0) {
                    error = 'Cost can not be negative.'
                }
                setErrors({ ...errors, [key]: error })
            }

            if (key === "charge_by") {
                setChargeDisabled(value === "no")
                if (value === "no") {
                    obj.add_base_price = false
                    obj.cost_by = 'flat'
                    if (Rate.shipping_ranges.length > 0 && rangesAdded(Rate.shipping_ranges)) {
                        // obj = { ...obj, shipping_ranges: [] }
                        // dispatch(setToast({ active: true, content: `Ranges will be erased and won't be restored.` }))
                    }
                } else if (value === "qty") {
                    obj.cost_by = 'qty'
                } else if (value === "weight") {
                    obj.unit = 'kg'
                    obj.cost_by = 'unit'
                }
            }
        }
        setRate({ ...Rate, ...obj })
    }

    const handleChangeRange = (key, value, i) => {
        const ranges = Rate.shipping_ranges
        ranges[i][key] = value
        setRate({ ...Rate, shipping_ranges: ranges })
        let e = ''
        if (value !== null && value !== '' && errors[i]) {
            if (key === "cost" && value < 0) {
                e = 'Cost can not be negative.'
            }
            setErrors({ ...errors, [i]: { ...errors[i], [key]: e } })
        }
    }
    const handleChangeConditions = (key, value) => {
        const conditions = Rate.shipping_conditions
        conditions[key] = value
        setRate({ ...Rate, shipping_conditions: conditions })
    }
    const addRange = () => {
        const shipping = Rate
        const ranges = shipping.shipping_ranges
        ranges.push({ ...emptyRange, shipping_id: Rate.id ? Rate.id : '' })
        shipping.shipping_ranges = ranges
        setRate(r => ({ ...r, ...shipping }))
    }
    const removeRange = i => {
        const ranges = Rate.shipping_ranges;
        setDeletedRanges([...DeletedRanges, ranges[i].id])
        ranges.splice(i, 1);
        setRate({ ...Rate, shipping_ranges: ranges })
    }

    const renderInput = () => {
        let element;
        if (Rate.shipping_by === 'zip') {
            let zipCodesAllowed = 0
            element = <Creatable
                esteric={true} // true for zipcode prefix allowed
                range={true} // true for zipcode ranges allowed
                label="ZipCodes"
                placeholder="Add ZipCodes"
                id="zip_codes"
                defaults={Rate.zip_codes}
                inputValue={zipInputValue}
                setInputValue={setZipInputValue}
                handleChange={handleChangeRate}
                handleInputChange={codes => { }}
                value={Rate.zip_codes ? Rate.zip_codes : []}
                error={Error}
                err={errors.zip_codes}
                valuesAllowed={zipCodesAllowed}
                setError={setError}
            />
        } else if (Rate.shipping_by === 'city') {
            // todo: input background red
            element = <Creatable
                inputValue={cityInputValue}
                setInputValue={setCityInputValue}
                label="Cities"
                id="cities"
                placeholder="Add Cities"
                defaults={Rate.cities}
                handleChange={handleChangeRate}
                value={Rate.cities}
                error={Error}
                err={errors.cities}
                valuesAllowed={5}
                setError={setError}
            />
        } else if (Rate.shipping_by === 'state' || Rate.shipping_by === 'countries') {
            let isStateAvailable = false;
            if (Rate.shipping_by === 'state') {
                for (const states of statesList) {
                    for (const state of states.options) {
                        if (state.value.includes(country.code)) {
                            isStateAvailable = true
                            break
                        }
                    }
                }
            } else {
                isStateAvailable = false;
            }
            element = <>
                {
                    Rate.shipping_by === "countries" ? <ReactSelect
                        placeholder={`Select Countries`}
                        err={errors.countries}
                        options={countries}
                        defaults={Rate.countries}
                        handleChange={countries => { handleChangeRate({ "countries": countries }) }}
                    /> : null
                }
                {
                    Rate.shipping_by === "state" ? <ReactSelect
                        placeholder={`Select States`}
                        err={errors.states}
                        groupdOptions={statesList}
                        defaults={Rate.states}
                        handleChange={states => {
                            handleChangeRate({ "states": states })
                        }}
                    /> : null
                }
                {!isStateAvailable && Rate.shipping_by === 'state' ? <span className="text">
                    <Badge status="attention">Shopify does not support provices in {country.name}</Badge>
                </span> : null}
            </>
        } else {
            element = <TextField type='text' placeholder='Select Shipping by option to add values' disabled={Rate.shipping_by === 'no'} onChange={() => dispatch(setToast({ active: true, content: 'This option is not available right now.' }))} />
        }
        return (
            <>
                {element}
                {
                    (Rate.shipping_by === 'zip' && errors.zip_codes === "Required*") ||
                        (Rate.shipping_by === 'city' && errors.cities === "Required*") ||
                        (Rate.shipping_by === 'state' && errors.states === "Required*") ||
                        (Rate.shipping_by === 'country' && errors.country === "Required*") ?
                        <div class="Polaris-Labelled__Error">
                            <div id="PolarisTextField3Error" class="Polaris-InlineError">
                                <div class="Polaris-InlineError__Icon">
                                    <Icon source={AlertCircleIcon} color="critical" />
                                </div>Required*</div>
                        </div>
                        : null
                }

                {
                    Rate.shipping_by === 'zip' ? <span className="rf-zip-help">
                        <ul>
                            <li>Copy & paste comma separated zipcode list e.g. 10001,10002,10003...</li>
                            <li>Enter zipcode range with (&gt;) e.g. <i className='X'><b>XXXXX&gt;XXXXX</b></i>, <i><b>10001&gt;10100</b></i></li>
                            <li>Enter zipcode prefixed with asteric(*) end. e.g. <i className='X'><b>XXX*</b></i>, <i><b>100*</b></i></li>
                        </ul>
                    </span> : null
                }
            </>
        )
    }
    const areaOptions = [
        { value: 'zip', label: 'Postal codes' },
        { value: 'city', label: 'Cities' },
        { value: 'state', label: 'States / Provinces' },
        { value: 'countries', label: 'Countries' },
        { value: 'no', label: 'Everywhere' }
    ]
    const chargeOptions = [
        { value: 'weight', label: 'Weight' },
        { value: 'qty', label: `Item quantity${!ranges ? ' (Pro)' : ''}` },
        { value: 'price', label: 'Cart value' },
        { value: 'no', label: 'Flat rate' }
    ]
    const unitOptions = [
        { value: 'kg', label: 'Kilogram' },
        { value: 'lb', label: 'Pound' },
        { value: 'oz', label: 'Ounce' }
    ]
    const areaValueKey = { zip: 'zip_codes', city: 'cities', state: 'states', countries: 'countries' }
    const areaHint = {
        zip: 'Customers with these postal codes will see this rate.',
        city: 'Customers in these cities will see this rate.',
        state: 'Customers in these states or provinces will see this rate.',
        countries: 'Customers in these countries will see this rate.',
        no: 'No area needed — every address sees this rate.'
    }
    const chargeHelp = {
        no: 'Every order pays the same price.',
        price: 'Set price bands by cart value — e.g. 0–50 costs 5.',
        weight: `Set price bands by order weight — e.g. 0–2 ${Rate.unit} costs 5.`,
        qty: 'Set price bands by number of items — e.g. 1–3 items costs 5.'
    }

    const saveShippingRate = async () => {
        await saveRate(Rate, rateId, ratesPermission, checkout_ui, exceptions, conditions, setIsSaving, dispatch, DeletedRanges, setErrors, navigate, true, fetchJson)
    }

    const deleteRate = async id => {
        try {
            setDeleting(true)
            await fetchJson(`/shipping/${id}`, {
                method: 'DELETE'
            })
            navigate("/rates")
        } catch (error) {
            console.log(error);
        } finally {
            setDeleting(false)
        }
    }

    // ---- derived values for the summary panel ----
    const isFixed = Rate.charge_by === 'no'
    const areaValues = Rate.shipping_by === 'no' ? [] : (Rate[areaValueKey[Rate.shipping_by]] || [])
    const areaValueLabels = areaValues.map(v => (v && typeof v === 'object' ? v.label ?? v.value : v)).filter(Boolean)
    const whereText = Rate.shipping_by === 'no'
        ? 'any address'
        : (areaValueLabels.length
            ? (areaValueLabels.length > 3 ? `${areaValueLabels.slice(0, 3).join(', ')} and ${areaValueLabels.length - 3} more` : areaValueLabels.join(', '))
            : `[${(areaOptions.find(a => a.value === Rate.shipping_by)?.label || '').toLowerCase()}]`)
    const unitWord = Rate.charge_by === 'weight' ? weightUnits[Rate.unit] : 'item'
    const chargeName = { no: 'flat rate', price: 'cart value', weight: 'weight', qty: 'item quantity' }[Rate.charge_by]
    const perUnit = (Rate.charge_by === 'weight' && Rate.cost_by !== 'flat') || (Rate.charge_by === 'qty' && Rate.cost_by !== 'flat')
    const percent = Rate.charge_by === 'price' && Rate.priceBy === '%'
    const priceText = isFixed
        ? (Rate.default_cost !== '' && Rate.default_cost !== null ? `${Rate.default_cost} ${Rate.currency}` : '[price]')
        : (percent ? 'a % of the cart value' : perUnit ? `a cost per ${unitWord}` : `a price based on ${chargeName}`)
    const priceShort = isFixed
        ? (Rate.default_cost !== '' && Rate.default_cost !== null ? `${Rate.default_cost} ${Rate.currency}` : '[Price]')
        : `[By ${chargeName}]`
    let condText = ''
    if (conditions.includes('min_spent') && Rate.shipping_conditions.min_spent) condText += `, on orders of ${Rate.shipping_conditions.min_spent} or more`
    if (conditions.includes('max_spent') && Rate.shipping_conditions.max_spent) condText += `${condText ? ' and' : ', on orders'} up to ${Rate.shipping_conditions.max_spent}`

    const checks = [
        { label: 'Display name', ok: Boolean(Rate.display_name && Rate.display_name.trim()) },
        { label: 'Delivery area', ok: Rate.shipping_by === 'no' || areaValues.length > 0 },
        { label: isFixed ? 'Price' : 'At least one price range', ok: isFixed ? (Rate.default_cost !== '' && Rate.default_cost !== null) : Rate.shipping_ranges.some(r => r.cost !== '' && r.cost !== null) }
    ]

    const labelSuggest = `${Rate.display_name || 'New rate'} · ${areaOptions.find(a => a.value === Rate.shipping_by)?.label || ''}`

    // Range cost type ("Each range costs") — same values the old ChoiceList used.
    const costTypes = Rate.charge_by === 'price'
        ? [{ value: 'flat', label: 'Fixed amount' }, { value: '%', label: 'Percentage of cart value' }]
        : [{ value: 'flat', label: 'Fixed amount' }, { value: Rate.charge_by === 'weight' ? 'unit' : 'qty', label: `Per ${unitWord}` }]
    const costTypeValue = Rate.charge_by === 'price' ? Rate.priceBy : Rate.cost_by
    const setCostType = value => handleChangeRate(Rate.charge_by === 'price' ? { "priceBy": value } : { "cost_by": value })
    const costHint = costTypeValue === 'flat'
        ? 'One amount for the whole order when it falls in the range.'
        : (Rate.charge_by === 'price' ? 'A % of the cart value, e.g. 10% of 40 = 4.' : `Multiplied by the ${Rate.charge_by === 'weight' ? 'order weight' : 'number of items'}, e.g. 2 per ${unitWord} × 3 = 6.`)

    const advTag = <span className="rf-adv-tag">Advanced</span>

    return (<>
        <div className="rf-page"><Page
            fullWidth
            title={`${rateId ? 'Edit' : 'Create'} shipping rate`}
            backAction={{ content: 'Rates', onAction: () => navigate('/rates') }}
            primaryAction={{ content: rateId ? 'Update' : 'Save rate', loading: isSaving, disabled: isSaving, onAction: () => saveShippingRate() }}
            secondaryActions={rateId ? [{ content: 'Delete', destructive: true, onAction: () => setOpenWarning(true) }] : []}
        >
            <div className="rf-wrap">
                <BlockStack gap="400">
                    {/* Mode bar */}
                    <Card>
                        <InlineStack gap="400" blockAlign="center" wrap>
                            <div className="rf-seg" role="tablist" aria-label="Form mode">
                                <button type="button" role="tab" aria-selected={!advanced} className={!advanced ? 'on' : ''} onClick={() => setAdvanced(false)}>Simple</button>
                                <button type="button" role="tab" aria-selected={advanced} className={advanced ? 'on' : ''} onClick={() => setAdvanced(true)}>Advanced</button>
                            </div>
                            <Text as="span" tone="subdued">
                                {advanced
                                    ? 'Showing every setting. Extra options are marked Advanced. Your Simple answers are kept.'
                                    : 'Just the essentials: name, where and price. Switch to Advanced any time — nothing you typed is lost.'}
                            </Text>
                        </InlineStack>
                    </Card>

                    <Layout>
                        <Layout.Section>
                            <BlockStack gap="400">
                                {/* 1. What customers see */}
                                <Card>
                                    <BlockStack gap="400">
                                        <BlockStack gap="050">
                                            <Text as="h2" variant="headingMd">1. What customers see</Text>
                                            <Text as="p" tone="subdued">Shown at checkout next to the price.</Text>
                                        </BlockStack>
                                        <TextField type="text" label="Display name" autoComplete="off" placeholder="e.g. Standard Shipping" error={errors.display_name ? errors.display_name : ''} value={Rate.display_name} onChange={(value) => handleChangeRate({ "display_name": value })} />
                                        {advanced ? (
                                            <div className="rf-adv">
                                                <InlineGrid columns={{ xs: 1, md: 2 }} gap="300">
                                                    <AdvancedOptions
                                                        codeValue={Rate.service_code}
                                                        handleChange={handleChangeRate}
                                                        descriptionValue={Rate.description}
                                                        rows={3}
                                                        chars={Rate.description ? Rate.description.length : 0}
                                                        maxChars={255}
                                                        disabled={!ratesPermission}
                                                    />
                                                    <TextField type="text" autoComplete="off" label={`Delivery in days${checkout_ui ? "" : " (Pro)"}`} placeholder='e.g. 4-5 or 5' disabled={!checkout_ui} error={errors.delivery ? errors.delivery : ''} value={Rate.delivery} onChange={(value) => {
                                                        if (checkout_ui) {
                                                            if (value === "" || validateInput(value)) {
                                                                handleChangeRate({ "delivery": value })
                                                                if (value !== "") {
                                                                    setErrors(errors => ({ ...errors, delivery: validateString(value) }))
                                                                }
                                                            }
                                                        } else {
                                                            dispatch(setToast({ active: true, content: "This feature is not available in current plan.", error: true }))
                                                        }
                                                    }} />
                                                </InlineGrid>
                                            </div>
                                        ) : null}
                                    </BlockStack>
                                </Card>

                                {/* 2. Where it applies */}
                                <Card>
                                    <BlockStack gap="400">
                                        <BlockStack gap="050">
                                            <Text as="h2" variant="headingMd">2. Where it applies</Text>
                                            <Text as="p" tone="subdued">Only customers with a matching address see this rate.</Text>
                                        </BlockStack>
                                        <BlockStack gap="200">
                                            <Text as="span" fontWeight="semibold" id="rf-area-label">Delivery area</Text>
                                            <div className="rf-pills" role="radiogroup" aria-labelledby="rf-area-label">
                                                {areaOptions.map(option => (
                                                    <button key={option.value} type="button" role="radio" aria-checked={Rate.shipping_by === option.value} className={`rf-pill${Rate.shipping_by === option.value ? ' on' : ''}`} onClick={() => handleChangeRate({ "shipping_by": option.value })}>
                                                        {option.label}
                                                    </button>
                                                ))}
                                            </div>
                                        </BlockStack>
                                        {Rate.shipping_by !== 'no' ? renderInput() : null}
                                        <Text as="p" variant="bodySm" tone="subdued">{areaHint[Rate.shipping_by]}</Text>
                                        {advanced ? (
                                            <div className="rf-adv">
                                                <Text as="span" fontWeight="semibold">Exclude areas{advTag}{exp ? '' : ' (Pro)'}</Text>
                                                <ShippingExceptions disabled={!exp} shippingBy={Rate.shipping_by} handleChange={handleChangeRate} rate={Rate} setExceptions={setExceptions} />
                                            </div>
                                        ) : null}
                                    </BlockStack>
                                </Card>

                                {/* 3. Price */}
                                <Card>
                                    <BlockStack gap="400">
                                        <BlockStack gap="050">
                                            <Text as="h2" variant="headingMd">3. Price</Text>
                                            <Text as="p" tone="subdued">{chargeHelp[Rate.charge_by]}</Text>
                                        </BlockStack>
                                        <BlockStack gap="200">
                                            <Text as="span" fontWeight="semibold" id="rf-charge-label">Price based on</Text>
                                            <div className="rf-pills" role="radiogroup" aria-labelledby="rf-charge-label">
                                                {chargeOptions.map(option => (
                                                    <button key={option.value} type="button" role="radio" aria-checked={Rate.charge_by === option.value} disabled={!ranges} className={`rf-pill${Rate.charge_by === option.value ? ' on' : ''}`} onClick={() => {
                                                        if (ranges) {
                                                            handleChangeRate({ "charge_by": option.value })
                                                        } else {
                                                            dispatch(setToast({ active: true, content: 'This feature is not available in current plan.' }))
                                                        }
                                                    }}>
                                                        {option.label}
                                                    </button>
                                                ))}
                                            </div>
                                        </BlockStack>

                                        {Rate.charge_by === 'weight' ? (
                                            <BlockStack gap="200">
                                                <Text as="span" fontWeight="semibold" id="rf-unit-label">Weight unit</Text>
                                                <div className="rf-pills" role="radiogroup" aria-labelledby="rf-unit-label">
                                                    {unitOptions.map(option => (
                                                        <button key={option.value} type="button" role="radio" aria-checked={Rate.unit === option.value} className={`rf-pill sm${Rate.unit === option.value ? ' on' : ''}`} onClick={() => handleChangeRate({ "unit": option.value })}>
                                                            {option.label}
                                                        </button>
                                                    ))}
                                                </div>
                                            </BlockStack>
                                        ) : null}

                                        {isFixed ? (
                                            <Box maxWidth="280px">
                                                <TextField
                                                    type="number"
                                                    min={0}
                                                    label="Price"
                                                    placeholder="00.0"
                                                    autoComplete="off"
                                                    value={Rate.default_cost}
                                                    error={errors.default_cost ? errors.default_cost : ''}
                                                    onChange={value => handleChangeRate({ "default_cost": value })}
                                                    suffix={Rate.currency}
                                                />
                                            </Box>
                                        ) : (
                                            <div className="rf-ranges">
                                                <InlineStack gap="300" blockAlign="center" wrap>
                                                    <Text as="span" fontWeight="semibold">Each range costs</Text>
                                                    <div className="rf-seg sm" role="radiogroup" aria-label="Range cost type">
                                                        {costTypes.map(option => (
                                                            <button key={option.value} type="button" role="radio" aria-checked={costTypeValue === option.value} className={costTypeValue === option.value ? 'on' : ''} onClick={() => setCostType(option.value)}>{option.label}</button>
                                                        ))}
                                                    </div>
                                                    <Text as="span" variant="bodySm" tone="subdued">{costHint}</Text>
                                                </InlineStack>
                                                <Divider />
                                                <div className="rf-range-head"><span>From</span><span>Up to</span><span>{percent ? 'Percentage' : perUnit ? `Cost per ${unitWord}` : 'Shipping cost'}</span><span /></div>
                                                {Rate.shipping_ranges.map((range, i) => (
                                                    <div key={i} className="rf-range-row">
                                                        <TextField labelHidden label="From" autoComplete="off" value={range.from} min={0} type="number" placeholder='0' disabled={chargeDisabled} error={errors[i] ? errors[i].from : ''} onChange={value => { if (!chargeDisabled) { handleChangeRange("from", value, i) } else { dispatch(setToast({ active: true, content: 'This option is not available right now.' })) } }} suffix={Rate.charge_by === "weight" ? Rate.unit : Rate.charge_by === "qty" ? 'items' : ""} prefix={Rate.charge_by === "price" ? formatCurrency(store.money_format) : ''} />
                                                        <TextField labelHidden label="Up to" autoComplete="off" value={range.upto} min={0} type="number" placeholder='No limit' disabled={chargeDisabled} error={errors[i] ? errors[i].upto : ''} onChange={value => { if (!chargeDisabled) { handleChangeRange("upto", value, i) } else { dispatch(setToast({ active: true, content: 'This option is not available right now.' })) } }} suffix={Rate.charge_by === "weight" ? Rate.unit : Rate.charge_by === "qty" ? 'items' : ""} prefix={Rate.charge_by === "price" ? formatCurrency(store.money_format) : ''} />
                                                        <TextField labelHidden label="Cost" autoComplete="off" value={range.cost} min={0} type="number" placeholder='0.00' disabled={chargeDisabled} error={errors[i] ? errors[i].cost : ''} onChange={value => { if (!chargeDisabled) { handleChangeRange("cost", value, i) } else { dispatch(setToast({ active: true, content: 'This option is not available right now.' })) } }} prefix={percent ? '' : formatCurrency(store.money_format)} suffix={percent ? '%' : perUnit ? `/${Rate.charge_by === 'weight' ? Rate.unit : 'item'}` : ''} />
                                                        <Button variant="tertiary" tone="critical" icon={DeleteIcon} accessibilityLabel={`Remove range ${i + 1}`} disabled={Rate.shipping_ranges.length <= 1} onClick={() => removeRange(i)} />
                                                    </div>
                                                ))}
                                                <InlineStack gap="300" blockAlign="center" wrap>
                                                    <Button disabled={chargeDisabled} onClick={() => {
                                                        if (chargeDisabled) {
                                                            dispatch(setToast({ active: true, content: 'This option is not available right now.' }))
                                                        } else if (!ranges) {
                                                            dispatch(setToast({ active: true, content: `Only Three ranges allowed in current plan.`, error: true }))
                                                        } else {
                                                            addRange(false)
                                                        }
                                                    }}>+ Add range</Button>
                                                    <Text as="span" variant="bodySm" tone="subdued">Leave "Up to" empty on the last row to cover everything above it.</Text>
                                                </InlineStack>
                                            </div>
                                        )}

                                        {advanced ? (
                                            <div className="rf-adv">
                                                {isFixed ? (
                                                    <Checkbox
                                                        label={<>Multiply price with quantity{advTag}</>}
                                                        helpText="3 items pay 3 × the price."
                                                        checked={Rate.multiply_base_price}
                                                        onChange={value => handleChangeRate({ "multiply_base_price": value })}
                                                    />
                                                ) : (
                                                    <>
                                                        <Checkbox
                                                            label={<>Add an extra charge on top{advTag}</>}
                                                            helpText="e.g. a handling fee added to every order."
                                                            checked={Rate.add_base_price}
                                                            onChange={value => handleChangeRate({ "add_base_price": value })}
                                                        />
                                                        {Rate.add_base_price ? (
                                                            <InlineGrid columns={{ xs: 1, md: 2 }} gap="300">
                                                                <TextField
                                                                    type="number"
                                                                    min={0}
                                                                    label="Extra charge"
                                                                    placeholder="00.0"
                                                                    autoComplete="off"
                                                                    value={Rate.default_cost}
                                                                    error={errors.default_cost ? errors.default_cost : ''}
                                                                    onChange={value => handleChangeRate({ "default_cost": value })}
                                                                    suffix={Rate.currency}
                                                                />
                                                                <Box paddingBlockStart="600">
                                                                    <Checkbox
                                                                        label="Multiply with quantity"
                                                                        checked={Rate.multiply_base_price}
                                                                        onChange={value => handleChangeRate({ "multiply_base_price": value })}
                                                                    />
                                                                </Box>
                                                            </InlineGrid>
                                                        ) : null}
                                                    </>
                                                )}
                                            </div>
                                        ) : null}
                                    </BlockStack>
                                </Card>

                                {/* 4. Order limits (Advanced) */}
                                {advanced ? (
                                    <Card>
                                        <BlockStack gap="400">
                                            <BlockStack gap="050">
                                                <Text as="h2" variant="headingMd">4. Order limits{advTag}</Text>
                                                <Text as="p" tone="subdued">Show this rate only for certain order totals.</Text>
                                            </BlockStack>
                                            <ChoiceList
                                                allowMultiple
                                                title="Order limits"
                                                titleHidden
                                                choices={[
                                                    {
                                                        label: "Minimum spent",
                                                        value: 'min_spent',
                                                        helpText: "Show only when the order total is at least this.",
                                                        renderChildren: isSelected => isSelected ? (
                                                            <TextField labelHidden label="Minimum spent" autoComplete="off" value={`${Rate.shipping_conditions.min_spent ?? ''}`} min={0} type="number" placeholder='0.00' prefix={formatCurrency(store.money_format)} onChange={value => { handleChangeConditions("min_spent", value) }} />
                                                        ) : null
                                                    },
                                                    {
                                                        label: "Maximum spent",
                                                        value: 'max_spent',
                                                        helpText: "Hide when the order total is above this.",
                                                        renderChildren: isSelected => isSelected ? (
                                                            <TextField labelHidden label="Maximum spent" autoComplete="off" value={`${Rate.shipping_conditions.max_spent ?? ''}`} min={0} type="number" placeholder='0.00' prefix={formatCurrency(store.money_format)} onChange={value => { handleChangeConditions("max_spent", value) }} />
                                                        ) : null
                                                    },
                                                ]}
                                                selected={conditions}
                                                onChange={handleChangeCondition}
                                            />
                                        </BlockStack>
                                    </Card>
                                ) : (
                                    <Box background="bg-surface" borderRadius="300" borderWidth="025" borderColor="border" padding="300">
                                        <InlineStack align="space-between" blockAlign="center" gap="300" wrap>
                                            <Text as="span" tone="subdued">Need a description, exclusions, extra charges or order limits?</Text>
                                            <Button onClick={() => setAdvanced(true)}>Show advanced options</Button>
                                        </InlineStack>
                                    </Box>
                                )}
                            </BlockStack>
                        </Layout.Section>

                        {/* ---- Summary ---- */}
                        <Layout.Section variant="oneThird">
                            <div className="rf-sticky">
                                <BlockStack gap="400">
                                    <Card>
                                        <BlockStack gap="400">
                                            <div className="rf-label-head">
                                                {editLabel ? (
                                                    <BlockStack gap="200">
                                                        <TextField label="Private label" helpText="Only you see this, in your rates list." autoComplete="off" placeholder={labelSuggest} error={errors.title ? errors.title : ''} value={Rate.title ?? ''} onChange={value => handleChangeRate({ "title": value })} />
                                                        <InlineStack align="end"><Button size="slim" onClick={() => setEditLabel(false)}>Done</Button></InlineStack>
                                                    </BlockStack>
                                                ) : (
                                                    <button type="button" className="rf-label-btn" onClick={() => setEditLabel(true)} aria-label="Edit private label">
                                                        <span className="rf-label-dot" aria-hidden="true" />
                                                        <span style={{ flexGrow: 1, minWidth: 0 }}>
                                                            <span className="rf-label-caption">Private label · only you</span>
                                                            <Text as="span" variant="headingSm" truncate>{Rate.title || labelSuggest}</Text>
                                                        </span>
                                                        <Icon source={EditIcon} tone="subdued" />
                                                    </button>
                                                )}
                                            </div>

                                            <InlineStack align="space-between" blockAlign="center">
                                                <Text as="h2" variant="headingSm">Summary</Text>
                                                <CustomToggle active={Rate.active} handleToggle={value => handleChangeRate({ "active": value })} />
                                            </InlineStack>

                                            <Text as="p">Customers shipping to <Text as="span" fontWeight="semibold">{whereText}</Text> will see <Text as="span" fontWeight="semibold">“{Rate.display_name || 'Standard Shipping'}”</Text> for <Text as="span" fontWeight="semibold">{priceText}</Text>{condText}.</Text>

                                            <BlockStack gap="100">
                                                <div className="rf-preview">
                                                    <span className="rf-radio" aria-hidden="true" />
                                                    <span style={{ flexGrow: 1 }}>
                                                        <BlockStack gap="050">
                                                            <Text as="span" fontWeight="semibold">{Rate.display_name || 'Standard Shipping'}</Text>
                                                            <Text as="span" tone="subdued">{Rate.description || 'Description appears here'}</Text>
                                                        </BlockStack>
                                                    </span>
                                                    <Text as="span" fontWeight="bold">{priceShort}</Text>
                                                </div>
                                                <Text as="span" variant="bodySm" tone="subdued">Checkout preview</Text>
                                            </BlockStack>

                                            <Divider />
                                            <BlockStack gap="200">
                                                {checks.map(check => (
                                                    <InlineStack key={check.label} gap="200" blockAlign="center" wrap={false}>
                                                        <span className={`rf-check${check.ok ? ' ok' : ''}`} aria-hidden="true">✓</span>
                                                        <Text as="span" tone={check.ok ? undefined : 'subdued'}>{check.label}</Text>
                                                    </InlineStack>
                                                ))}
                                            </BlockStack>
                                            <Button variant="primary" fullWidth loading={isSaving} disabled={isSaving} onClick={() => saveShippingRate()}>{rateId ? 'Update' : 'Save rate'}</Button>
                                        </BlockStack>
                                    </Card>

                                    <Card>
                                        <InlineStack gap="300" blockAlign="center" wrap={false}>
                                            <Icon source={PlayCircleIcon} tone="critical" />
                                            <BlockStack gap="050">
                                                <Button variant="plain" url="https://www.youtube.com/watch?v=JmR2i_qtWWw" external>How to add Shipping Rate</Button>
                                                <Text as="span" variant="bodySm" tone="subdued">Video walkthrough</Text>
                                            </BlockStack>
                                        </InlineStack>
                                    </Card>
                                </BlockStack>
                            </div>
                        </Layout.Section>
                    </Layout>
                </BlockStack>
            </div>
            <PolarisModal
                active={OpenWarning}
                modalTitle={`Warning`}
                primaryAction={{ content: 'No', onAction: () => setOpenWarning(false) }}
                secondaryActions={[{
                    content: 'Yes', loading: deleting, disabled: deleting, destructive: true, onAction: async () => {
                        await deleteRate(rateId)
                        setOpenWarning(false)
                    }
                }]}
                handleClose={() => setOpenWarning(false)}
                component={<WarningCard width="100%" margin="0px auto" title="Are you confirm to delete this shipping?" status="warning" message="" />}
            />
        </Page ></div>
    </>
    )
}

export default RateSetting;
